import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class ZPrinterZReportResult {
  @MappedProperty()
  date?: string;

  @MappedProperty()
  total_documents?: number;
}
